import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "extractUsername",
    standalone: true,
})
export class ExtractUsernamePipe implements PipeTransform {
    transform(value: string, ...args: unknown[]): unknown {
        //   remove string after @ from email and return string before @
        return value.split("@")[0];
    }
}
